module.exports = __tmimport("~endpoint:{controller: \'customized/shop\', action: \'cms_page_preview_render\'}");